$(document).ready(function () {
  // Search Bar Script
  $('.searchBoxInput input').attr('placeholder', 'Search')
  $('.searchBoxInput input').val('')
  $('#mobileSearchInput').attr('placeholder', 'Search Website')
  $('#mobileSearchInput').val('')

  // Tickets & Deals
  $('.ticket').text("Tickets")
  $('.mobile-menu-ticket-btn').text("Tickets")

  // TOGGLE
  $('.mobile-nav-toggle').append(`
<div></div>
<div></div>
<div></div>
`)

  // Class for nav items (radius)
  $('.groups .group').each(function () {

    $(this).find('.items > .item').each(function () {
      $(this).addClass('radius-class');

      $(this).find(".subitems > .item").each(function () {
        $(this).addClass(`radius-class`);
      });
    });

    $(this).find('.navClonedItem').removeClass('radius-class')
  });

  // General Message
  $('.generalmessage').prependTo('header');

  // Feature LineUp Customized
    let nmbrSlides = 1
  $('.featureLineupModule .featureLineupContainer').each(function () {
    $(this).find(".subContainer .featureLineupImage").prepend('<div class="overlay-lineup"></div>')
  
  })

});




